import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        countableInfo: css` display: inline-flex `,
        countIndicator: css`
            margin-left: 8px;
            background: ${theme.palette.secondary.dark};
            color: ${theme.palette.common.white};
            border-radius: 5px;
            padding: 0 5px;
        `,
    }
}

export default styles
